<script>
import {db, auth} from '../../../db';

export default{
  name: 'SettingsNotifications',
  data(){
    return{
      testerNotifButtons:[
        {name: 'Playtest updates', subtext:'Receive emails about new playtest sessions you joined', key: 'playtestNotification'},
        {name: 'Survey updates', subtext:'Receive emails about new surveys from joined playtests', key: 'surveyNotification'},
        {name: 'Recommended playtest notifications', subtext:'Receive emails about new game projects we think might be a fit for you', key: 'discoverPlaytestNotification'},
      ],
      testerNotificationSettings: {
        playtestNotification: true,
        surveyNotification: true,
        discoverPlaytestNotification: true,
      },
      developerNotifButtons:[
        {name: 'Playtest updates', subtext:'Receive emails about new finished playtests', key: 'playtestNotification'},
        {name: 'Survey updates', subtext:'Receive emails about new finished surveys', key: 'surveyNotification'},
      ],
      developerNotificationSettings: {
        playtestNotification: true,
        surveyNotification: true,
      },
      isLoading: true,
      uid:"",
      userType:"",
    }
  },
  mounted: async function() {
    try{
      this.uid = auth.currentUser.uid;
      const userDoc = await db.collection("User").doc(this.uid).get();
      const notifications = userDoc.get("settings.notifications");
      this.userType = userDoc.get("userType");
      if(this.userType === "tester"){
        this.testerNotificationSettings.playtestNotification = notifications.playtestNotification;
        this.testerNotificationSettings.surveyNotification = notifications.surveyNotification;
        this.testerNotificationSettings.discoverPlaytestNotification = notifications.discoverPlaytestNotification;
      } else if(this.userType === "developer"){
        this.developerNotificationSettings.playtestNotification = notifications.playtestNotification;
        this.developerNotificationSettings.surveyNotification = notifications.surveyNotification;
      }else{throw new Error("User type does not match required types")}
      
    }catch(err){
       console.error("Error loading notification settings:", err);
    }finally {
      this.isLoading = false // This switches the loading flag
    }
  },
  methods:{
    async updateNotification(buttonKey){
      try{
        const docRef = db.collection('User').doc(this.uid);
        const userDoc = await docRef.get();

        if (!userDoc.exists) {
          return { success: false, message: "User not found, something went wrong" };
        }

        await docRef.update({
          [`settings.notifications.${buttonKey}`]:this.developerNotificationSettings[buttonKey]
        });
        
        console.log("updates of ", buttonKey, " was successful");
      }catch(err){
        throw new Error("Failed to change setting", { cause: err });
      }
      
    },
  },
}
</script>

<template>
  <section v-if="!this.isLoading">
    <h4>Emails</h4>
    <ul v-if="userType === 'tester'" class="tabs-list">
      <li class="buttons" v-for="button in testerNotifButtons" :key="button.key">
        <input class="toggle" type="checkbox" v-model="testerNotificationSettings[button.key]" @change="updateNotification(button.key)"/>
        <span class="button-title">{{ button.name }}</span>
        <div class="button-subtext">{{ button.subtext }}</div>
      </li>
    </ul>
    <ul v-else-if="userType === 'developer'" class="tabs-list">
      <li class="buttons" v-for="button in developerNotifButtons" :key="button.key">
        <input class="toggle" type="checkbox" v-model="developerNotificationSettings[button.key]" @change="updateNotification(button.key)"/>
        <span class="button-title">{{ button.name }}</span>
        <div class="button-subtext">{{ button.subtext }}</div>
      </li>
    </ul>
  </section>
</template>

<style scoped>
h4{
  color:#ff7222;
  justify-content: center;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #ff7222;
}
ul{
  all:unset;
}
.tabs-list{
  list-style: none;
}
.buttons{
  display:grid;
  grid-template:
  'toggle title' minmax(0.5rem, max-content)
  '.  subtxt' 
  ;
  grid-gap: 0 0.5rem;
  justify-content: start;
  margin-bottom: 1rem;
}
.toggle{
  grid-area: toggle;
  max-width: max-content;
  height: auto;
}
.button-title{
  grid-area: title;
  min-height: 0;
  height: 100%;
  align-content: center;
}
.button-subtext{
  font-size: small;
  color:#5b5b5b;
  grid-area: subtxt;
}
</style>


// WEBPACK FOOTER //
// src/components/settings/SettingsTabs/Notifications.vue